import { ActionsLeadType } from '@crm/components'
import { MenuProps } from 'antd'
import { TFunction } from 'i18next'

import { Bookmark2, Profile2User, Status, Tag, Trash } from 'iconsax-react'
import { NavigateFunction } from 'react-router-dom'

type ActionsProps = (
  ids: number[],
  options: {
    t: TFunction
    checkedLeads: number[]
    setSelectedLeads: (state: { ids: number[]; type?: ActionsLeadType }) => void
    navigate: NavigateFunction
    isAdmin?: boolean
  }
) => Required<MenuProps>['items']

const commonActionColumnItem: ActionsProps = (
  ids: number[],
  { t, setSelectedLeads, isAdmin }
) => [
  {
    label: t('contacts.re_assign_responsible'),
    key: 'reAssignResponsible',
    icon: <Profile2User size={20} />,
    onClick: () => setSelectedLeads({ ids, type: 'assignTo' })
  },
  {
    label: t('contacts.set_tag'),
    key: 'setTag',
    icon: <Tag size={20} />,
    onClick: () => setSelectedLeads({ ids, type: 'setTag' })
  },
  ...(isAdmin
    ? [
        {
          label: t('contacts.send_to_campaign'),
          key: 'sendToCampaign',
          icon: <Bookmark2 size={20} />,
          onClick: () => setSelectedLeads({ ids, type: 'campaignsListForm' })
        }
      ]
    : []),
  {
    label: t('contacts.change_status'),
    key: 'changeStatus',
    icon: <Status size={20} />,
    onClick: () => setSelectedLeads({ ids, type: 'changeStatus' })
  },
  { type: 'divider' },
  {
    label: t('contacts.delete_record'),
    key: 'deleteRecord',
    icon: <Trash size={20} />,
    danger: true,
    onClick: () => setSelectedLeads({ ids, type: 'delete' })
  }
]

export const getActionColumnItem: ActionsProps = (ids, options) => [
  ...commonActionColumnItem(ids, options)
]
